import { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export function useSettings() {
    return useContext(SettingsContext);
}

export function SettingsProvider({ children }) {
    const [fontScale, setFontScale] = useState(() => {
        if (typeof window !== 'undefined') {
            const saved = localStorage.getItem('fontScale');
            return saved ? parseFloat(saved) : 1;
        }
        return 1;
    });

    useEffect(() => {
        const root = document.documentElement;
        // Imposta la dimensione del font in percentuale (es. 100%, 110%, 90%)
        // La base di Tailwind/Browser è solitamente 16px (100%)
        root.style.fontSize = `${fontScale * 100}%`;
        localStorage.setItem('fontScale', fontScale.toString());
    }, [fontScale]);

    const value = {
        fontScale,
        setFontScale
    };

    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    );
}
